import { render } from "./ModalTemplatePreview.vue?vue&type=template&id=47c19410&scoped=true"
import script from "./ModalTemplatePreview.vue?vue&type=script&lang=js"
export * from "./ModalTemplatePreview.vue?vue&type=script&lang=js"

import "./ModalTemplatePreview.vue?vue&type=style&index=0&id=47c19410&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47c19410"

export default script